export default __webpack_public_path__ + "static/media/internalbleed2.a30ef42e.png";